module.exports = __webpack_public_path__ + "static/media/play.7940c158.svg";